import React from 'react';
import './login_lms.css';
import { useState } from 'react';
import { Divider, Input } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { validateEmail, validatePassword, parseJwt } from '../../utility/validation';
import { encryptPassword } from '../../utility/encryption';
import warning from '../../assets/warning.svg'
import { userLogin, googleLogin } from '../../service/UserService';
import { login, setPortal } from "../../redux/authentication/authActions";
import Toast from '../../components/shared/toast/Toast';
import { PayloadBuilder } from '../../utility/payloadBuilder';
import { Button } from 'antd/lib';
import { GoogleLogin, useGoogleOneTapLogin } from "@react-oauth/google";
import PageLoader from '../../components/global/Loader/PageLoader';
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import { getAccessToken, getRefreshToken, setAccessToken, setRefreshToken, clearTokens, setStoredUsername } from '../../utility/interceptors/axiosInstance';
import useDevToolsGuard from '../../hooks/useDevToolsGuard';

const Login_lms = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    useDevToolsGuard();

    const [showPassword, setShowPassword] = useState(false);
    const [userEmail, setUserEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState({ email: '', password: '' });
    const [toastMessage, setToastMessage] = useState('');
    const [showToast, setShowToast] = useState(false);
    const [toastType, setToastType] = useState('');
    const [loading, setLoading] = useState(false);

    const togglePassword = () => setShowPassword(!showPassword);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'email') setUserEmail(value);
        if (name === 'password') setPassword(value);
        setError({
            ...error,
            [name]: '',
        });
    };

    const handleSubmit = async (e) => {
    e.preventDefault();

    const result_email = validateEmail(userEmail);
    const result_pass = validatePassword(password);

    if (!result_email.valid || !result_pass.valid) {
        setError({ email: result_email.message, password: result_pass.message });
        return;
    }

    try {
        setLoading(true);

        const encryptedPassword = encryptPassword(password);
        const response = await userLogin({ email: userEmail, password: encryptedPassword });
        const accessToken = response.headers['x-access-token'];
        const refreshToken = response.headers['x-refresh-token'];
        const { id, fullName, email, username, roles } = response.data;
        setStoredUsername(username);
        const normalizedRoles = Array.isArray(roles) ? roles : [roles];
        console.log({normalizedRoles})
        const isAdmin = normalizedRoles.some(role =>["ADMIN", "ADMIN_SUPPORT"].includes(role));
        const currP = isAdmin ? "admin" : "user";
        await dispatch(
          login({
            id,
            fullName,
            email,
            username,
            roles: normalizedRoles,
            currentPortal: isAdmin ? "admin" : "user",
          }),
        );
        setAccessToken(accessToken);
        setRefreshToken(refreshToken);

        if (normalizedRoles.includes('ADMIN') || normalizedRoles.includes('ADMIN_SUPPORT')) {
            navigate('/admin');
        } else if (normalizedRoles.includes('EMPLOYEE')) {
            navigate('/user', { state: { userId: id, name: fullName } });
        } else {
            navigate('/');
        }
    } catch (err) {
        setToastMessage('Invalid credentials!');
        setToastType('error');
        setShowToast(true);
    } finally {
        setLoading(false);
    }
};

const handleGoogleSuccess = async (credentialResponse) => {
    try {
        const googleToken = credentialResponse.credential;
        const response = await googleLogin({ googleToken });
        const accessToken = response.headers['x-access-token'];
        const refreshToken = response.headers['x-refresh-token'];
        const { id, fullName, email, username } = response.data;
        setStoredUsername(username);
        const roles = parseJwt(accessToken)?.roles;
        const normalizedRoles = Array.isArray(roles) ? roles : [roles];
        const isAdmin = normalizedRoles.some((role) =>
          ["ADMIN", "ADMIN_SUPPORT"].includes(role),
        );
        const currP = isAdmin ? "admin" : "user";

        dispatch(
          login({
            id,
            fullName,
            email,
            username,
            roles: normalizedRoles,
            currentPortal: currP,
          }),
        );
        setAccessToken(accessToken);
        setRefreshToken(refreshToken);

        if (normalizedRoles.includes('ADMIN') || normalizedRoles.includes('ADMIN_SUPPORT')) {
            navigate('/admin');
        } else if (normalizedRoles.includes('EMPLOYEE')) {
            navigate('/user', { state: { userId: id, name: fullName } });
        } else {
            navigate('/');
        }
    } catch (err) {
        console.error('Google login failed', err);
    }
};

    const handleGoogleError = () => {
    };


    return (
        <div className="login-page">
             <PageLoader visible={loading} /> 
            <div className="login-container">
                <h1 className="login-title-lms">Login</h1>
                <p className="login-subtitle-lms">Welcome to LMS</p>
                <form onSubmit={handleSubmit}>
                    <div className="form-group-login">
                        <div className="input-container">
                            <input
                                type="email"
                                className={`form-input ${error.email ? "error" : ""}`}
                                placeholder={error.email ? error.email : "Email"}
                                name="email"
                                value={userEmail}
                                onChange={handleInputChange}
                            />
                            {error.email && (
                                <img src={warning} alt="error" className="warning-icon error" />
                            )}
                        </div>
                    </div>
                    <div className="form-group-login">
                        <div className="password-input-container">
                            <input
                                type={showPassword ? "text" : "password"}
                                className={`form-input ${error.password ? "error" : ""}`}
                                placeholder={error.password ? error.password : "Password"}
                                name="password"
                                value={password}
                                onChange={handleInputChange}
                            />
                            <button
                                type="button"
                                className="password-toggle"
                                onClick={togglePassword}
                            >
                                {showPassword ? (
                                    <EyeOutlined className="eye-icon" />
                                ) : (
                                    <EyeInvisibleOutlined className="eye-icon" />
                                )}
                            </button>
                        </div>
                    </div>
                    <button type="submit" className="login-button">
                        Login
                    </button>
                </form>
                <a href="/forget-password" className="forgot-password"  >
                    Forgot Password?
                </a>
                <div className="divider">Or</div>
                <div className="flex justify-center">
                    <GoogleLogin
                        onSuccess={handleGoogleSuccess}
                        onError={handleGoogleError}
                        useOneTap
                        text="signin_with"
                        size="large"
                        width="100%"
                    />
                </div>


                <Toast
                    message={toastMessage}
                    type={toastType}
                    show={showToast}
                    onClose={() => setShowToast(false)}
                />
            </div>
        </div>
    );
};

export default Login_lms;